import { IContactSocials } from 'models/Contact/IContactSocials'
import { ISocialMedia } from 'models/Common/ISocialMedia'
import { TranslationKeys } from 'types/TranslationKeys'

export interface AboutProps {
  isAr: boolean
  socialMedia: ISocialMedia[] | null
  contactSocials: IContactSocials[] | null
  t: (key: TranslationKeys) => string
}

export const useAbout = (props: AboutProps) => {
  return {
    ...props,
  }
}
